import React, { Suspense, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";

import { getUserDetail, isLoggedIn } from "src/utilities/SessionService";
import Loader from "src/components/Shared/Loader/Loader";

// ------------------------- Containers -------------------------
const Login = React.lazy(() => import("src/views/pages/login/Login"));
const Register = React.lazy(() => import("src/views/pages/register/Register"));

const DefaultStructure = React.lazy(() => import("../DefaultStructure"));

// ------------------------- Paths Constant -------------------------
const ADMIN = "/admin";

export const LOGIN = "/login";
// export const REGISTER = "/register";

export const DASHBOARD = "/dashboard";
export const USER_MANAGEMENT = "/user-management";
export const GROUP_MANAGEMENT = "/group-management";
export const TRANSPORTATION_MANAGEMENT = "/transportation-management";
export const MASTERS = "/masters";
export const EXTRAS = "/extras";
export const EXPENSE = "/expense";
export const NEWEXPENSE = "/new-expense";

export const CHAT = "/CHAT";
export const DOCUMENTS = "/documents";
export const REPORT = "/report";
export const REPORTLIST = "/reportlist";

// ------------------------- Paths Array -------------------------

export const pathsUniversal = [];

export const pathsUnAuthenticated = [LOGIN];

export const pathsAuthenticated = [DASHBOARD, USER_MANAGEMENT, GROUP_MANAGEMENT, MASTERS, EXTRAS, EXPENSE, NEWEXPENSE, CHAT, DOCUMENTS];

// ------------------------- Router -------------------------

const index = () => {
  const rootDetail = useSelector(({ root }) => root);
  const navigate = useNavigate();
  // const userDetail = getUserDetail();

  useEffect(() => {
    // Anything in here is fired on component mount.
    return () => {
      // Anything in here is fired on component unmount.
    };
  }, []);

  useEffect(() => {
    // Anything in here is fired on component did update.
    if (!isRedirectPathExistIn(pathsUniversal)) {
      if (rootDetail.isAuthenticated) {
        if (isRedirectPathExistIn(pathsUnAuthenticated)) {
          navigate(DASHBOARD, { replace: true });
        }
      } else {
        if (isRedirectPathExistIn(pathsAuthenticated)) {
          navigate(LOGIN, { replace: true });
        }
      }
    }
  });

  const isRedirectPathExistIn = (paths) => {
    const isExist = paths.filter((item) => window.location.href.indexOf(item) !== -1).length > 0;
    return isExist;
  };

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* If no matching path found navigate to sample*/}
        <Route path="/" element={<Navigate to={LOGIN} replace />} />

        <Route exact path={LOGIN} element={<Login />} />

        {/* <Route path={REGISTER} element={<Register />} /> */}

        <Route path="*" element={<DefaultStructure />} />
      </Routes>
    </Suspense>
  );
};

export default index;
